import React from 'react';
import { Card, CardBody, CardHeader, Container, Row, Col, Collapse } from 'reactstrap';
import Host from './Host';
import ServiceStatus from './ServiceStatus';

const toColor = state => {
  switch (state) {
    case 'UP':
      return '';
    case 'DOWN':
      return 'danger';
    case 'PEND':
      return 'info';
    case 'UNREACH':
      return 'secondary';
    default:
      return 'dark';
  }
};

const DataCenter = ({ name, hosts }) => {
  const [isOpen, setOpen] = React.useState(true);
  const toggle = () => {
    setOpen(!isOpen);
  };
  return (
    <Card key={name} style={{ minWidth: 200, border: 0 }}>
      <CardHeader
        color="info"
        style={{ cursor: 'pointer', background: 'none', border: 0 }}
        onClick={toggle}
      >
        <div
          style={{
            position: 'absolute',
            float: 'right',
            right: 10,
            top: 5,
            opacity: +!isOpen,
            transition: 'opacity .5s, visibility .5s',
          }}
        >
          <ServiceStatus
            services={{
              ok: hosts.reduce((acc, host) => acc + host.services.ok, 0),
              critical: hosts.reduce((acc, host) => acc + host.services.critical, 0),
              warning: hosts.reduce((acc, host) => acc + host.services.warning, 0),
              pending: hosts.reduce((acc, host) => acc + host.services.pending, 0),
              unknown: hosts.reduce((acc, host) => acc + host.services.unknown, 0),
            }}
          />
        </div>
        {name} <small>({hosts.length} hosts)</small>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody style={{ borderTop: '1px solid #eee' }}>
          <Container>
            <Row>
              {hosts.map(host => (
                <Col
                  xs="fluid"
                  sm={6}
                  md={4}
                  lg={3}
                  xl={3}
                  xxl={2}
                  key={host.name}
                  style={{ padding: '0 2px' }}
                >
                  <Host
                    color={toColor(host.state)}
                    services={host.services}
                    name={host.description}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default DataCenter;
